import { ReactNode } from "react";
import CloseIcon from "../../../assets/icons/close";
import "./AppModalHeader.css";

interface AppModalHeaderProps {
  children: ReactNode;
  onClose?: () => void;
}

export default function AppModalHeader({
  children,
  onClose,
}: AppModalHeaderProps) {
  return (
    <div className="app-modal-header">
      <div className="app-modal-header-title">{children}</div>
      {onClose && (
        <button
          aria-label="close"
          data-test="close"
          className="app-modal-header-close"
          onClick={onClose}
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
}
